import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { NewReaction } from '@/types/models';
import { ONE } from '@/constants/common';
import { REACTIONS_INITIAL_STATE } from './reactions.constants';
import {
  getReactionsForModelReducer,
  resetHighlightReactionsDataReducer,
  setHighlightReactionsByIdsReducer,
  setHighlightReactionsReducer,
  setLoadingHighlightReactionsDataReducer,
} from './reactions.reducers';

export const reactionsSlice = createSlice({
  name: 'reactions',
  initialState: REACTIONS_INITIAL_STATE,
  reducers: {
    resetHighlightReactionsData: resetHighlightReactionsDataReducer,
    setHighlightReactions: setHighlightReactionsReducer,
    setHighlightReactionsByIds: setHighlightReactionsByIdsReducer,
    setLoadingHighlightReactionsData: setLoadingHighlightReactionsDataReducer,
    reactionUpdate: (state, action: PayloadAction<{ modelId: number; reaction: NewReaction }>) => {
      const { modelId, reaction } = action.payload;
      const modelData = state.data[modelId];
      if (modelData?.data) {
        const index = modelData.data.findIndex(r => r.id === reaction.id);
        if (index !== -ONE) {
          modelData.data[index] = reaction;
        }
      }
    },
    reactionDelete: (state, action: PayloadAction<{ modelId: number; reactionId: number }>) => {
      const { modelId, reactionId } = action.payload;
      const modelData = state.data[modelId];
      if (modelData?.data) {
        modelData.data = modelData.data.filter(r => r.id !== reactionId);
      }
    },
  },
  extraReducers: builder => {
    getReactionsForModelReducer(builder);
  },
});

export const {
  resetHighlightReactionsData,
  setHighlightReactions,
  setHighlightReactionsByIds,
  setLoadingHighlightReactionsData,
  reactionUpdate,
  reactionDelete,
} = reactionsSlice.actions;

export default reactionsSlice.reducer;
